import { render, staticRenderFns } from "./HealthPlanSettings.vue?vue&type=template&id=6f54dd4d&scoped=true"
import script from "./HealthPlanSettings.vue?vue&type=script&lang=ts"
export * from "./HealthPlanSettings.vue?vue&type=script&lang=ts"
import style0 from "./HealthPlanSettings.vue?vue&type=style&index=0&id=6f54dd4d&prod&lang=scss"
import style1 from "./HealthPlanSettings.vue?vue&type=style&index=1&id=6f54dd4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f54dd4d",
  null
  
)

export default component.exports